import { ChainId } from '@cronosdex/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.CRONOSMAINNET]: '0x6F522a3982e8F9A50A2EDc9E46ed1A3aE2B3FD3a'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
